export default {"src":"/_next/static/media/effective-medical-applications.97d7287b.svg","height":75,"width":90,"blurWidth":0,"blurHeight":0};